define('vspot-angular/services/org-invitation-service',[], function () {
    'use strict';

    return ['resources.OrgInvitation', function (OrgInvitation) {

        return {
            /*
             * Get a list of all the invitations. Results are paginated.
             *
             * @param sortType - How the data should be sorted from the server.
             *                  The options sent are the language file key for the
             *                  options shown to the user. i.e. "_StartDate_", "_EndDate_", "_Alphabetical_".
             *
             * @param hidePastEvents - Whether or not to show activities wit no current jobs.
             * @param hideArchivedInvitations - Whether or not to show archived invitiatons.
             * @param currentPage - Which page of the result set to show. 1 is the default.
             * @param itemsPerPage - How many items to show on each page of the result set. 10 is the default.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(sortType, hidePastEvents, hideArchivedInvitations, currentPage, itemsPerPage) {

                return OrgInvitation.get({
                    order:                      sortType,
                    hide_past_events:           hidePastEvents,
                    hide_archived_invitations:  hideArchivedInvitations,
                    page:                       currentPage,
                    items_per_page:             itemsPerPage
                });
            },

            /*
             * This function actually moves the invitation into an archived state.
             */
            delete: function(id) {
                return OrgInvitation.delete({
                    id:     id
                });
            },

            /*
             * For an invitation that have been "destroyed", we can use this
             * function to restore it.
             */
            restoreArchivedInvitation: function(id) {
                return OrgInvitation.restoreArchivedInvitation({
                    id:     id
                });
            }
        };
    }];
});

